import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../../Model/Combo/combo.service';
import { EmployeeReportingToService } from '../../../Model/ReportingToService/employee-reporting-to.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-client-head',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './client-head.component.html',
  styleUrl: './client-head.component.scss'
})
export class ClientHeadComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  UserLoad: any[] = [];
  ClientLoad : any[] = [];
  ClientId:any= null;
  ClientName: string = '';
  ClientDataLoad : any[] = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private EmployeeService: EmployeeReportingToService,
    protected common:CommonService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('GetEssUserMaster');
    this.ComboLoad('Client');
  }
  
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        console.log('API Response', response);
        if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad; 
        } else if (Combotype == 'Client') {
          this.ClientLoad = response.ComboLoad;
        } 
      },
      complete: () => {
      },
      error: (error) => {
      },  
    });
  }
  Search(){
    this.GetData()
  }
  GetData(){
    const ReportingToData = {
      SelectType: 'ReportingToClient',
      ClientID: this.ClientId
    }
    console.log( 'Dataa',ReportingToData);
    this.isDisabled = true ;
    this.EmployeeService.EmployeeReportingToSelect(ReportingToData).subscribe(
      data => {
        this.ClientDataLoad = Object.values(data.Table);
        console.log('new data', data);
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false
      }
    );
  }
  async save(){
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
       if(this.common.PageRight.IsEdit){
          this.Update();
        }
      }
    }).catch(() => {

    });
  }
  Update() {
    if (this.ClientDataLoad.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    this.User = this.sessionService.GetUserDetails();
    const Data = this.ClientDataLoad.map(rt => {
      return {
        ClientID: rt.ClientGroupMasterID,
        ClientOwnerId: rt.ClientOwnerId,
      };
    });
    const ReportData = {
      SelectType: 'Update',
      ESS_ReportingToClient: Data,
      UserId: this.User.UserId
    }
    console.log('Reporting Data ', ReportData);
    this.isDisabled = true;
    this.EmployeeService.ReportingToClient(ReportData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.ClientDataLoad = []
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
        this.Search();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  onSelectChange(type: string) {
   if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
    }
  }

  clear(){
    this.ClientDataLoad = [];
  }
}
